import { useEffect } from "react";
import { useScreenContext } from "../Layout";
import InfoImage from "../../assets/images/info.png";
import { useTranslation } from "react-i18next";

function Info() {
  const { t } = useTranslation();
  const [screenData, setScreenData] = useScreenContext();

  useEffect(() => {
    setScreenData(() => ({
      ...screenData,
      submitLabel: t("layout.cta_continue"),
      nextPath: "loading",
      progress: 77,
      votting: false,
    }));
  }, []);

  return (
    <div>
      <h1 className="mx-0 mb-4 mt-5 text-xl font-bold tracking-tight text-gray-900 dark:text-white md:text-4xl">
        {t("info.headline")}
      </h1>
      <p className="font-light">{t("info.subheadline")}</p>
      <img
        className="mx-auto mt-10 max-w-sm px-10"
        alt="Chart showing your progress"
        src={InfoImage}
      />
    </div>
  );
}

export default Info;
